import React from 'react';

import styled from '@emotion/styled';

import { Text, mq } from '@clutter/clean';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--Backgrounds-Background-Teal, #e8f6f5);
  margin: 0 auto;
  position: relative;
  ${mq({
    padding: ['40px 0px', '60px 0px', '94px 0px'],
    gap: ['24px', '30px'],
  })}
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  ${mq({
    gap: ['24px', '30px'],
    marginLeft: ['16px', '24px', '156px'],
    marginRight: ['16px', '24px', '156px'],
  })}
`;

const Headline = styled(Text.Display)`
  color: var(--Text-Panther, #000);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: Recoleta;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  ${mq({
    width: ['100%', '100%', '100%'],
    fontSize: ['32px !important', '32px !important', '40px !important'],
  })}
`;

const Description = styled(Text.Body)`
  color: var(--Text-Panther, #000);
  font-family: 'Basier Square';
  font-style: normal;
  font-weight: 400;
  ${mq({
    width: ['100%', '100%', '100%'],
    fontSize: ['18px', '20px', '24px'],
    lineHeight: ['140%', '140%', '120%'],
  })}
`;

export const ValueProposition: React.FC = () => {
  return (
    <Container>
      <ContentWrapper>
        <Headline>Your one-stop shop for quality and calm</Headline>
        <Description>
          Clutter is the only full-service, tech-enabled solution built for
          smart, busy people (that’s you!). We bring you fully customizable,
          high-quality service and reliability across North America. Give
          Clutter the clutter and we’ll give you the calm.
        </Description>
      </ContentWrapper>
    </Container>
  );
};
